
<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
  </div>
  
  <main id="content" role="main" class="main">
      <div class="content container">
          <div >
              <nav aria-label="breadcrumb">
                  <ol id="w6" class="breadcrumb">
                      <li class="breadcrumb-item"><a routerLink="/Investment/Dashboard">{{'home'|translate}}</a></li>
                      <li class="breadcrumb-item active" aria-current="page">الاعفائات</li>
                  </ol>
              </nav>
          </div>
      </div>
  
      <div class="row justify-content-center py-7" style="background:url(/img/bg-green-full.png);">
          <div class="col-md-8 col-12">
  
              <div class="js-step-form" >
                  <div id="basicStepFormContent">
                      <div id="basicStepDetails" class="card">
                          <div >
                              <div class="card-header">
                                  <h3 class="card-title h3">
                                      الجمارك
                                  </h3>
                              </div>
  
                              <div class="card-body">
                                  <form [formGroup]="form" (ngSubmit)="onSubmit()">
  
                                      <div class="row">
                                        <div class="col-md-4 form-group py-2">
                                            <label for="taxNumber" class="pb-2">الرقم الضريبي:</label>
                                            <input type="text" id="taxNumber" formControlName="taxNumber" class="form-control" readonly>
                                              <div *ngIf="form.get('taxNumber')?.invalid && formSubmited" class="text-danger">
                                                  حقل اجباري
                                              </div>
                                        </div>
                                      </div>

                                      <hr>

                                      <div class="row align-items-center">
                                        
                                        <div class="col-md-4 form-group py-2">
                                            <label for="licenseId" class="pb-2">رقم الرخصة:</label>
                                            <input type="text" id="licenseId" formControlName="licenseId" class="form-control">
                                              <div *ngIf="(form.get('licenseId')?.invalid && formSubmited) || showLicenseError" class="text-danger">
                                                  حقل اجباري
                                              </div>
                                        </div>
                                        
                                      </div>

                                      <div class="row py-2 text-center" *ngIf="showSearchBtn==true">
                                        <div class="col-md-12">
                                            <button type="button" class="btn btn-primary" (click)="fillApplicant(form.get('licenseId')?.value,true)">بحث</button>
                                        </div>
                                      </div>
  
                                      <hr>
                                    
                                      <!-- Form Items -->

                                      <ng-container *ngIf="showJamarek">
                                        <div class="row">
                                          <div class="col-12">
                                              <p>
                                                العناصر المستوردة
                                              </p>
                                          </div>
                                        </div>
    
                                        <div formArrayName="formItems">
                                          <div *ngFor="let item of Items.controls; let i = index">
    
                                            <!-- <div class="row"  *ngIf="item.get('fromDb')?.value==false">
                                                <div class="col-12" style="text-align: left;">
                                                    <i role="button"
                                                        (click)="removeJamarek(i)"
                                                        class="fa-solid fa-trash text-danger p-2"
                                                        style="padding: 7px;border: 2px solid #eee;border-radius: 5px;"></i>
                                                </div>
                                            </div> -->
    
    
                                            <div [formGroupName]="i" class="mb-3">
    
                                              <input type="hidden" formControlName="id">
    
                                              <div class="row">
                                                <div class="col-md-6 col-12">
                                                  <div class="form-group py-2">
                                                    <label for="unitName-{{i}}">اكتب للبحث:</label>
                                                    <input type="text" id="unitName-{{i}}" formControlName="unitName" (blur)="getUnits($event,i)"  class="form-control">
                                                    <div *ngIf="item.get('unitName')?.invalid && formSubmited" class="text-danger">
                                                        حقل اجباري
                                                    </div>
                                                   
                                                  </div>
                                                </div>
    
                                                <div class="col-md-6 col-12">
                                                  <div class="form-group py-2">
                                                    <label for="unitId-{{i}}">العنصر:</label>
                                                    <select id="unitId-{{i}}" formControlName="unitId" class="form-control" (change)="onUnitIdChange($event, i)">
                                                      <option value="">يرجى الاختيار</option>
                                                      <option value="{{item.key }}" *ngFor="let item of units[i]" >{{item.value }}</option>
                                                      <!-- ... -->
                                                    </select>
                                                    <div *ngIf="item.get('unitId')?.invalid && formSubmited" class="text-danger">
                                                        حقل اجباري
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
    
                                              <div class="row">
    
                                                <div class="col-md-6 col-12">
                                                  <div class="form-group py-2">
                                                    <label for="hsCode-{{i}}">hs code:</label>
                                                    <input type="text" id="hsCode-{{i}}" formControlName="hsCode" readonly="true" class="form-control">
                                                    <div *ngIf="item.get('hsCode')?.invalid && formSubmited" class="text-danger">
                                                        حقل اجباري
                                                    </div>
                                                  </div>
                                                </div>
    
    
                                                <div class="col-md-6 col-12">
                                                  <div class="form-group py-2">
                                                    <label for="quantity-{{i}}">الكمية:</label>
                                                    <input type="number" id="quantity-{{i}}" formControlName="quantity" class="form-control">
                                                    <div *ngIf="item.get('quantity')?.invalid && formSubmited" class="text-danger">
                                                        حقل اجباري
                                                    </div>
                                                  </div>
                                                </div>
    
    
                                              </div>
    
                                              <div class="row">
                                                <div class="col-md-6 col-12">
                                                  <div class="form-group py-2">
                                                    <label for="staticUnit-{{i}}">وحدة القياس :</label>
                                                    <select id="staticUnit-{{i}}" formControlName="staticUnit" class="form-control">
                                                        <option value="">يرجى الاختيار</option>
                                                        <option value="{{item.key}}" *ngFor="let item of statisticalUnits">
                                                        {{item.value}}
                                                      </option>
                                                      <!-- ... -->
                                                    </select>
                                                    <div *ngIf="item.get('staticUnit')?.invalid && formSubmited" class="text-danger">
                                                        حقل اجباري
                                                    </div>
                                                  </div>
                                                </div>
    
    
                                                <div class="col-md-6 col-12"  *ngIf="formType!='2'">
                                                  <label for="exemptAssets-{{i}}">قائمة الموجودات المعفاة :</label>
                                                  <div class="form-group py-2">
    
                                                    <p-dropdown [options]="exemptAssetsList" id="exemptAssets-{{i}}" formControlName="exemptAssets" optionValue="key"  [filter]="true" filterBy="key" [showClear]="false" placeholder="يرجى الاختيار"  [required]="true">
                                                      <ng-template pTemplate="selectedItem">
                                                          <div class="flex align-items-center gap-2" *ngIf="item.get('exemptAssets')?.value!='' ">
                                                              <div>{{ item.get('exemptAssets')?.value }}</div>
                                                          </div>
                                                      </ng-template>
                                                      <ng-template let-item pTemplate="item">
                                                          <div class="flex align-items-center gap-2">
                                                              <div>{{ item.value  }}</div>
                                                          </div>
                                                      </ng-template>
                                                  </p-dropdown>
    
                                                    <div *ngIf="item.get('exemptAssets')?.invalid && formSubmited" class="text-danger">
                                                        حقل اجباري
                                                    </div>
                                                  </div>
                                                </div>
    
                                              </div>
                                              
                                              <div class="row">
                                                <div class="col-md-6 col-12">
                                                  <div class="form-group py-2">
                                                    <label for="additionalCode-{{i}}">
                                                      رمز الاعفاء ( الرمز الاضافي)
                                                    </label>
                                                    
                                                    <input type="number" id="additionalCode-{{i}}" formControlName="additionalCode" class="form-control">
    
                                                    <div *ngIf="item.get('additionalCode')?.invalid && formSubmited" class="text-danger">
                                                      حقل اجباري
                                                  </div>
                                                   
                                                  </div>
                                                </div>
    
                                                <div class="col-md-6 col-12">
                                                  <div class="form-group py-2">
                                                    <label for="credits-{{i}}">الارصدة:</label>
                                                    <input type="number" id="credits-{{i}}" formControlName="credits" class="form-control">
    
                                                    <div *ngIf="item.get('credits')?.invalid && formSubmited" class="text-danger">
                                                      حقل اجباري
                                                  </div>
                                                  </div>
                                                </div>
                                                
                                              </div>
                                              
                                              <div class="row">
                                                <div class="col-12">
                                                  <div class="form-group py-2">
                                                    <label for="description-{{i}}">الوصف: </label>
                                                    <textarea type="text" id="description-{{i}}" formControlName="description" class="form-control" readonly></textarea>
                                                  </div>
                                                </div>
    
                                              </div>
    
                                              <div class="row">
                                                <div class="col-12">
                                                  <div class="form-group py-2">
                                                    <label for="note-{{i}}">ملاحظات الموظف: </label>
                                                    <textarea type="text" id="note-{{i}}" formControlName="note" class="form-control"></textarea>
                                                  </div>
                                                </div>
    
                                              </div>
    
                                            </div>



    
                                            <hr>
    
                                          </div>
    
                             
    
    
                                        </div>
    
    
                                        <hr>
                                      </ng-container>
  
                                      <ng-container *ngIf="showTax" >
                                      
                                         <!-- Form Items -->
  
                                      <div class="row">
                                        <div class="col-12">
                                            <p>
                                              العناصر المحلية
                                            </p>
                                        </div>
                                      </div>
                                      
                                      <div formArrayName="taxItems">
                                        <div *ngFor="let item of TaxItems.controls; let i = index">
  
                                          <!-- <div class="row" *ngIf="item.get('fromDb')?.value==false">
                                              <div class="col-12" style="text-align: left;">
                                                  <i role="button"
                                                      (click)="removeTax(i)"
                                                      class="fa-solid fa-trash text-danger p-2"
                                                      style="padding: 7px;border: 2px solid #eee;border-radius: 5px;"></i>
                                              </div>
                                          </div> -->
  
  
                                          <div [formGroupName]="i" class="mb-3">
  
                                            <input type="hidden" formControlName="id">
  
                                            <input type="hidden" formControlName="staticUnit" value="1">
                                            <input type="hidden" formControlName="hsCode" value="1">
                                            <input type="hidden" formControlName="unitId" value="1">
                                          


                                          <div class="row">
                                            <div class="col-md-6 col-12">
                                              <div class="form-group py-2">
                                                <label for="unitName-{{i}}">اسم العنصر :</label>
                                                <input type="text" id="unitName-{{i}}" formControlName="unitName"  class="form-control">
                                                <div *ngIf="item.get('unitName')?.invalid && formSubmited" class="text-danger">
                                                    حقل اجباري
                                                </div>
                                               
                                              </div>
                                            </div>

                                            <div class="col-md-6 col-12">
                                              <div class="form-group py-2">
                                                <label for="quantity-{{i}}">الكمية:</label>
                                                <input type="number" id="quantity-{{i}}" formControlName="quantity" class="form-control">
                                                <div *ngIf="item.get('quantity')?.invalid && formSubmited" class="text-danger">
                                                    حقل اجباري
                                                </div>
                                              </div>
                                            </div>

                                            <div class="col-md-6 col-12">
                                              <div class="form-group py-2">
                                                <label for="staticUnit-{{i}}">وحدة القياس :</label>
                                                <select id="staticUnit-{{i}}" formControlName="staticUnit" class="form-control">
                                                    <option value="">يرجى الاختيار</option>
                                                    <option value="{{item.key}}" *ngFor="let item of statisticalUnits">
                                                    {{item.value}}
                                                  </option>
                                                </select>
                                                <div *ngIf="item.get('staticUnit')?.invalid && formSubmited" class="text-danger">
                                                    حقل اجباري
                                                </div>
                                              </div>
                                            </div>

                                            <div class="col-md-6 col-12" *ngIf="formType=='2'">
                                              <div class="form-group py-2">
                                                <label for="totalPrice-{{i}}">القيمة بالدينار للقطعة الواحدة:</label>
                                                <input type="number" id="totalPrice-{{i}}" formControlName="totalPrice" class="form-control">
                                                <div *ngIf="item.get('totalPrice')?.invalid && formSubmited" class="text-danger">
                                                    حقل اجباري
                                                </div>
                                              </div>
                                            </div>

                                            <div class="col-md-6 col-12"  *ngIf="formType!='2'">
                                              <label for="exemptAssets-{{i}}">قائمة الموجودات المعفاة :</label>
                                              <div class="form-group py-2">

                                                <p-dropdown [options]="exemptAssetsList" id="exemptAssets-{{i}}" formControlName="exemptAssets" optionValue="key"  [filter]="true" filterBy="key" [showClear]="false" placeholder="يرجى الاختيار"  [required]="true">
                                                  <ng-template pTemplate="selectedItem">
                                                      <div class="flex align-items-center gap-2" *ngIf="item.get('exemptAssets')?.value!='' ">
                                                          <div>{{ item.get('exemptAssets')?.value }}</div>
                                                      </div>
                                                  </ng-template>
                                                  <ng-template let-item pTemplate="item">
                                                      <div class="flex align-items-center gap-2">
                                                          <div>{{ item.value  }}</div>
                                                      </div>
                                                  </ng-template>
                                              </p-dropdown>

                                                <div *ngIf="item.get('exemptAssets')?.invalid && formSubmited" class="text-danger">
                                                    حقل اجباري
                                                </div>
                                              </div>
                                            </div>

                                            
                                          </div>

                                          <div class="row">
                                            <div class="col-md-6 col-12">
                                              <div class="form-group py-2">
                                                <label for="additionalCode-{{i}}">
                                                  رمز الاعفاء ( الرمز الاضافي)
                                                </label>
                                                
                                                <input type="number" id="additionalCode-{{i}}" formControlName="additionalCode" class="form-control">

                                                <div *ngIf="item.get('additionalCode')?.invalid && formSubmited" class="text-danger">
                                                  حقل اجباري
                                              </div>
                                               
                                              </div>
                                            </div>

                                            <div class="col-md-6 col-12">
                                              <div class="form-group py-2">
                                                <label for="credits-{{i}}">الارصدة:</label>
                                                <input type="number" id="credits-{{i}}" formControlName="credits" class="form-control">

                                                <div *ngIf="item.get('credits')?.invalid && formSubmited" class="text-danger">
                                                  حقل اجباري
                                              </div>
                                              </div>
                                            </div>
                                            
                                          </div>
                                          
                                          <div class="row">
                                            <div class="col-12">
                                              <div class="form-group py-2">
                                                <label for="description-{{i}}">الوصف: </label>
                                                <textarea type="text" id="description-{{i}}" formControlName="description" class="form-control" readonly></textarea>
                                              </div>
                                            </div>

                                          </div>

                                          <div class="row">
                                            <div class="col-12">
                                              <div class="form-group py-2">
                                                <label for="note-{{i}}">ملاحظات الموظف: </label>
                                                <textarea type="text" id="note-{{i}}" formControlName="note" class="form-control"></textarea>
                                              </div>
                                            </div>

                                          </div>
                                          
                                            
  
                                          </div>
  
                                          <hr>
  
                                        </div>
  
  
                                      </div>
                                      
                                      </ng-container>
                                    
                                     
  
                                      <hr>
                                                                      
  
                                      <div class="row"  *ngIf="showSaveBtn">
                                        <div class="col-12" style="text-align: center;">
                                          <button type="submit" class="btn btn-primary">حفظ</button>
                                        </div>
                                      </div>
  
                                    </form>
                                    
                                    
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </main>